<template>
  <div class="rank-content">
    <div class="rank-info">
      <ul>
        <li
          v-for="(item, index) in props.rankList"
          :id="index == 1 ? 'theFirst' : ''"
          :key="index"
        >
          <img
            :src="getRankFlag(index)"
            alt=""
            v-show="index < 3"
            class="rankFlag"
          />
          <span v-show="index > 2">{{ index + 1 }}</span>
          <p>
            <img :src="item.avatar" alt="" />
            <span>{{ item.user_nicename }}</span>
          </p>
          <span>{{ item.count }}次</span>
        </li>
      </ul>
      <div class="my_rank">
        <span>{{ props.paiming.paiming }}</span>
        <p>
          <img :src="props.paiming.avatar" alt="" />
          <span>{{ props.paiming.user_nicename }}</span>
        </p>
        <span>{{ props.paiming.cjnumber }}次</span>
      </div>
      <img
        src="../../../../assets/webActivity/newYear/rankListImg/rank_award_banner.png"
        alt=""
      />

      <div class="award_info">
        <div class="left">
          <img
            src="../../../../assets/webActivity/newYear/rankListImg/rank_award_info.png"
            alt=""
          />
          <p>100余额</p>
        </div>
        <div class="right">
          <li>
            <img
              src="../../../../assets/webActivity/newYear/rankListImg/rank_award_info.png"
              alt=""
            />
            <p>60余额</p>
          </li>
          <li>
            <img
              src="../../../../assets/webActivity/newYear/rankListImg/rank_award_info.png"
              alt=""
            />
            <p>30余额</p>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, nextTick, computed } from "vue";

const getRankFlag = computed(() => {
  return function(rankNum) {
    if (rankNum == 0) {
      return require("../../../../assets/webActivity/newYear/rankListImg/rank_1.png");
    } else if (rankNum == 1) {
      return require("../../../../assets/webActivity/newYear/rankListImg/rank_2.png");
    } else {
      return require("../../../../assets/webActivity/newYear/rankListImg/rank_3.png");
    }
  };
});

const props = defineProps({
  rankList: {
    type: Array,
    default: () => [],
  },
  paiming: {
    type: Object,
    default: () => {},
  },
});

onMounted(() => {
  nextTick(() => {
    // console.log("rankList", props.rankList);
  });
});
</script>
<style scoped>
.rank-content {
  width: 100vw;
  min-height: 1762px;
  background-color: #92e2ff;
  padding: 36px 32px 94px;
}
.rank-info {
  width: 686px;
  min-height: 1762px;
  background: url(../../../../assets/webActivity/newYear/rankListImg/rank_bg.png),
    #356eff;
  border-radius: 40px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 142px 20px 0;
}
.rank-info ul {
  width: 100%;
  height: 1092px;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  padding: 38px 40px 28px;
  backdrop-filter: blur(18px);
  padding: 24px;
  padding-bottom: 100px;
}
.rank-info ul li {
  width: 100%;
  height: 92px;
  display: flex;
  align-items: center;
}
.rank-info ul li .rankFlag,
.rank-info ul li > span:nth-of-type(1) {
  width: 92px;
  height: 92px;
  text-align: center;
  line-height: 92px;
  font-weight: 800;
  color: #666666;
}
.rank-info ul li p {
  flex: 1;
  display: flex;
  align-items: center;
}
.rank-info ul li p img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-right: 12px;
}
.rank-info ul li span:nth-of-type(2) {
  font-size: 28px;
  color: #0048ff;
  font-weight: 800;
}
/* 我的排名 */
.my_rank {
  margin-top: -52px;
  width: 646px;
  height: 104px;
  background: #356eff;
  border-radius: 30px;
  border: 2px solid #ffffff;
  position: relative;
  z-index: 9;
  display: flex;
  align-items: center;
  padding: 0 24px 0 40px;
  font-size: 32px;
  font-weight: 800;
  color: #fff;
}
.my_rank p {
  flex: 1;
  margin-left: 26px;
  display: flex;
  align-items: center;
}
.my_rank p img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-right: 12px;
}

/* 排行榜底部奖励 */
.rank-info > img {
  width: 292px;
  height: 78px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
  margin-bottom: 28px;
}

/* 排名奖励 */
.award_info {
  width: 646px;
  min-height: 378px;
  display: flex;
  font-size: 20px;
  color: #fff;
  font-weight: 800;
}
.award_info .left {
  width: 306px;
  height: 378px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  backdrop-filter: blur(18px);
  margin-right: 20px;
  position: relative;
  padding-top: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.award_info .left::before {
  content: "";
  position: absolute;
  width: 214px;
  height: 60px;
  background-image: url(../../../../assets/webActivity/newYear/rankListImg/rank_award_first.png);
  background-size: 100% 100%;
  top: 0;
  left: -18px;
}

.award_info .left img {
  width: 296px;
  height: 232px;
  position: relative;
}

.award_info .left::after {
  content: "";
  position: absolute;
  top: 80px;
  left: 48px;
  width: 198px;
  height: 254px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  z-index: -1;
}
.award_info .left p {
  padding: 0 18px;
  height: 34px;
  background: linear-gradient(180deg, #ff4957 0%, #fa4aa0 100%);
  box-shadow: inset 0px -2px 0px 0px rgba(255, 255, 255, 0.25),
    inset 0px 2px 2px 0px #ffd3dd;
  border-radius: 40px;
  text-align: center;
  line-height: 34px;
}

.award_info .right li {
  width: 320px;
  height: 180px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  backdrop-filter: blur(18px);
  margin-bottom: 18px;
  display: flex;
  padding-left: 12px;
  align-items: center;
  padding-top: 18px;
  position: relative;
}
.award_info .right li img {
  width: 172px;
  height: 144px;
}
.award_info .right li p {
  padding: 0 18px;
  height: 34px;
  background: linear-gradient(180deg, #ff4957 0%, #fa4aa0 100%);
  box-shadow: inset 0px -2px 0px 0px rgba(255, 255, 255, 0.25),
    inset 0px 2px 2px 0px #ffd3dd;
  border-radius: 40px;
  text-align: center;
  line-height: 34px;
  margin-top: 20px;
}

.award_info .right li:nth-of-type(1)::before {
  content: "";
  position: absolute;
  width: 142px;
  height: 44px;
  background-image: url(../../../../assets/webActivity/newYear/rankListImg/rank_award_sec.png);
  background-size: 100% 100%;
  top: 0;
  left: 0;
}
.award_info .right li:nth-of-type(1)::after,
.award_info .right li:nth-of-type(2)::after {
  content: "";
  position: absolute;
  top: 54px;
  left: 38px;
  width: 264px;
  height: 106px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  z-index: -1;
}

.award_info .right li:nth-of-type(2)::before {
  content: "";
  position: absolute;
  width: 142px;
  height: 44px;
  background-image: url(../../../../assets/webActivity/newYear/rankListImg/rank_award_thr.png);
  background-size: 100% 100%;
  top: 0;
  left: 0;
}
</style>
